export default __webpack_public_path__ + "static/media/004-curve.8f7cd063.png";